import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LivenessService } from './liveness.service';
import * as AWS from 'aws-sdk';
import { FaceLivenessReactWrapperComponent } from 'src/FaceLivenessReactWrapperComponent';
import awsmobile from 'src/aws-exports';

@Component({
  selector: 'app-face-liveness',
  templateUrl: './face-liveness.component.html',
  styleUrls: ['./face-liveness.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FaceLivenessComponent implements OnInit {

  public counter = 21;

  start_liveness_session = false;
  liveness_session_complete = false;
  session_id = null;
  is_live = false;
  confidence = 0;
  face_live_message = 'Carregando ...'

  @ViewChild('faceliveness', { static: false }) faceliveness: FaceLivenessReactWrapperComponent;

  constructor(private faceLivenessService: LivenessService, private route: ActivatedRoute) {

  }

  ngOnInit(): void {
    this.faceLivenessService.liveness_session.subscribe(([status, data]) => {
      if (status == 'success') {
        this.initate_liveness_session(data);
      }
    })

    AWS.config.region = awsmobile['aws_project_region'];
    const cognito_endpoint = `cognito-idp.${awsmobile['aws_project_region']}.amazonaws.com/${awsmobile['aws_user_pools_id']}`
    // Initialize the Amazon Cognito credentials provider
    const session = this.faceLivenessService.get_current_session().then(data => {
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: awsmobile['aws_cognito_identity_pool_id'],
        Logins: {
          [cognito_endpoint]: data.getIdToken().getJwtToken()
        }
      });

      this.get_liveness_session()
    }).catch(err => {
      console.log(err)
    }
    );
  }

  public handleErrors(err: any) {
    this.liveness_session_complete = true;
    this.start_liveness_session = false;
    this.face_live_message = 'Erro durante validação'
    this.is_live = false;
    // Force remove the ReactDOM
    this.faceliveness.ngOnDestroy();
  }

  public handleLivenessAnalysisResults(data: any) {
    console.log(data);
    if (data['Confidence'] > 66) {
      this.is_live = true;
      this.face_live_message = `Liveness check ok, Confiabilidade ${Math.round(Number(data['Confidence']))}`
    } else {
      this.is_live = false;
      this.face_live_message = `Liveness check falhou, Confiabilidade ${Math.round(Number(data['Confidence']))}`
    }
    this.liveness_session_complete = true;
    this.start_liveness_session = false;
    // Force remove the ReactDOM
    console.log("After Liveness - Redirect");
    this.faceliveness.ngOnDestroy();
    const redirParam = this.route.snapshot.queryParams["redirect"];
    const actionParam = this.route.snapshot.queryParams["action"];
    const auditImage = data['AuditImages'][0].S3Object.Name
    console.log(auditImage)
    const redirUri=`https://peruibe.censomunicipal.com.br/${redirParam}&from=lvn&action=${actionParam}&img=${auditImage}`
    console.log(redirUri)
    if (redirParam)
      location.href=redirUri;
  }

  initate_liveness_session(data: {}) {
    this.is_live = false;
    this.session_id = data['SessionId'];
    this.confidence = 0;
    this.liveness_session_complete = false;
    setTimeout(() => {
      this.start_liveness_session = true;
    }, 3);
  }

  get_liveness_session() {
    this.start_liveness_session = false;
    this.faceLivenessService.get_face_liveness_session();
  }

}
